import React from "react";
import { process } from "../mock/mock";

const Process = () => {
  return (
    <section id="process" aria-labelledby="process-heading" className="relative py-24 md:py-32 bg-[#F2F1EC]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14">
          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#6b6b66] mb-3">
              — (04) Process
            </p>
            <h2 id="process-heading" className="font-display text-3xl md:text-4xl font-medium leading-tight">
              How we&apos;ll<br />work together.
            </h2>
          </div>
          <div className="lg:col-span-9 lg:pt-8">
            <p className="font-display text-2xl md:text-[28px] leading-[1.3] font-light text-[#1a1a1a] max-w-3xl">
              A senior, hands-on engagement structured to ship measurable
              visibility lift in 90 days — then keep compounding.
            </p>
          </div>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute left-0 right-0 top-[42px] h-px bg-[#0A0A0A]/15" />
          <ol className="grid grid-cols-1 md:grid-cols-5 gap-6 md:gap-4">
            {process.map((p, i) => (
              <li key={p.step} className="relative">
                <div className="hidden md:flex absolute left-0 top-[34px] h-4 w-4 rounded-full bg-[#FAFAF7] border-2 border-[#0A0A0A] items-center justify-center">
                  <span className="h-1.5 w-1.5 rounded-full bg-[#C8FF3D]"></span>
                </div>
                <div className="md:pl-7 pt-0 md:pt-16">
                  <div className="flex items-baseline gap-3 mb-3">
                    <span className="font-mono text-xs text-[#6b6b66]">{p.step}</span>
                    <span className="hidden md:block h-px flex-1 bg-[#0A0A0A]/10" />
                  </div>
                  <h3 className="font-display text-xl md:text-[22px] font-medium leading-snug mb-3">
                    {p.title}
                  </h3>
                  <p className="text-[14px] leading-relaxed text-[#2a2a2a]">
                    {p.detail}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default Process;
